import { useTranslation } from 'react-i18next'
import type { Company } from '../types'

interface CompanyStatsCardsProps {
  companies: Company[]
  total: number
}

export function CompanyStatsCards({ companies, total }: CompanyStatsCardsProps) {
  const { t } = useTranslation()

  const inProgress = companies.filter((c) => c.status === 'in-progress').length
  const completed = companies.filter((c) => c.status === 'completed').length
  const notStarted = companies.filter((c) => c.status === 'not-started').length

  const stats = [
    {
      label: t('companies.stats.total'),
      value: total,
      cardClass: 'border-border bg-card',
      valueClass: 'text-foreground',
    },
    {
      label: t('companies.stats.inProgress'),
      value: inProgress,
      cardClass: 'bg-[var(--status-in-progress-bg)] border-[var(--status-in-progress-text)]/20',
      valueClass: 'text-[var(--status-in-progress-text)]',
    },
    {
      label: t('companies.stats.completed'),
      value: completed,
      cardClass: 'bg-[var(--status-completed-bg)] border-[var(--status-completed-text)]/20',
      valueClass: 'text-[var(--status-completed-text)]',
    },
    {
      label: t('companies.stats.notStarted'),
      value: notStarted,
      cardClass: 'bg-[var(--status-not-started-bg)] border-[var(--status-not-started-text)]/20',
      valueClass: 'text-[var(--status-not-started-text)]',
    },
  ]

  return (
    <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.label} className={`rounded-lg border p-4 ${stat.cardClass}`}>
          <p className="text-muted-foreground text-[10px] font-semibold tracking-wider uppercase">
            {stat.label}
          </p>
          <p className={`mt-1 text-2xl font-bold ${stat.valueClass}`}>{stat.value}</p>
        </div>
      ))}
    </div>
  )
}
